import { useAPIContext } from "context/APIContext";
import { useEditBPMNContext } from "context/EditBPMNContext";
import { useEditKEALinkContext } from "context/EditKEALinkContext";
import { useEditLabelContext } from "context/EditLabelContext";
import { useEditPositionLabelContext } from "context/EditPositionLabelModalContext";
import { useEditUMLContext } from "context/EditUMLContext";
import { useEditUMLLifeLineContext } from "context/EditUMLLifeLineContext";
import { useErrorMessageContext } from "context/ErrorModalContext";
import { useKEAGraphContext } from "context/KEAGraphContext";
import { useModelingLanguageContext } from "context/ModelLanguageContext";
import { useNameModelModalContext } from "context/NameModelModalContext";
import { useTaskContext } from "context/TaskContext";
import { useUserSettingsContext } from "context/UserSettingsContext";
import { dimension, useWindowSizeContext, windowPadding } from "context/WindowSizeContext";
import { ContentView } from "pages/assessment/content/ContentView";
import { useEffect, useState } from "react";
import { ContentContainer } from "shared/ContentContainer";
import { useCallbackRef } from "shared/misc/UseCallbackRef";
import { useAssessmentContext } from "../../context/AssessmentContext";
import { FooterContainer } from "./footer/FooterContainer";

interface Props {}

export const AssessmentEditor = (_props: Props) => {
  const labelContext = useEditLabelContext();
  const positonLabelContext = useEditPositionLabelContext();
  const umlContext = useEditUMLContext();
  const bpmnContext = useEditBPMNContext();
  const lifeLineContext = useEditUMLLifeLineContext();
  const windowSizeContext = useWindowSizeContext();
  const modelingLanguageContext = useModelingLanguageContext();
  const assessmentContext = useAssessmentContext();
  const nameModelModalContext = useNameModelModalContext();
  const apiContext = useAPIContext();
  const keaGraphContext = useKEAGraphContext();
  const errorModalContext = useErrorMessageContext();
  const taskContext = useTaskContext();
  const kealinkContext = useEditKEALinkContext();
  const userSettingsContext = useUserSettingsContext();

  const [contentDimension, setContentDimension] = useState<dimension>({
    width: 1,
    height: 1,
  });

  const [footerHeight, setFooterRef] = useCallbackRef((node: any) => node?.clientHeight || 0);

  const setNodeWrapper = (node: joint.dia.Element) => {
    umlContext.setNode(node);
    bpmnContext.setNode(node);
    lifeLineContext.setNode(node);
    labelContext.setNode(node);
    kealinkContext.setNode(node);
    positonLabelContext.setNode(node);
  };

  useEffect(() => {
    setContentDimension({
      width: windowSizeContext.dimension.width,
      height: windowSizeContext.dimension.height - (footerHeight as unknown as number) - windowPadding,
    });
  }, [footerHeight, windowSizeContext.dimension.height, windowSizeContext.dimension.width]);

  return (
    <>
      <ContentContainer width={windowSizeContext.dimension.width} height={contentDimension.height}>
        <ContentView
          width={windowSizeContext.dimension.width}
          height={contentDimension.height}
          setNode={setNodeWrapper}
          setModelLanguage={modelingLanguageContext.setModelingLanguage}
          setModelName={nameModelModalContext.setName}
          modelLanguage={modelingLanguageContext.modelingLanguage}
          userCanChangeModelingLanguage={modelingLanguageContext.userCanChangeModelingLanguage}
          modelId={assessmentContext.modelId}
          exerciseId={assessmentContext.exerciseId}
          apiManager={apiContext.apiManager}
          modelingGraph={keaGraphContext.modelingGraph}
          toggleErrorModal={errorModalContext.toggleErrorModal}
          pushPresent={keaGraphContext.pushPresent}
          setShowTask={taskContext.setShowTask}
          setMarkdown={taskContext.setMarkdown}
          setDescription={taskContext.setDescription}
          addUserInteraction={keaGraphContext.addUserInteraction}
          userSettingsContext={userSettingsContext}
          keaGraphContext={keaGraphContext}
        />
      </ContentContainer>
      <FooterContainer ref={setFooterRef} />
    </>
  );
};
